import { ComboRow, IUpload } from './coremodels';

export function generateTrackId(): string {
  const timestamp = Date.now().toString(36); // Base36 lowercase (~8 chars)
  const random = Math.random().toString(36).substring(2, 7); // Random lowercase (5 chars)

  // Combine and convert the entire string to uppercase
  // Total Length: ~13 characters (e.g., "LRC87X7W4F9G2")
  return `${timestamp}${random}`.toUpperCase();
}

export const fileBiz = async (payload: any): Promise<Blob> => {
  const res = await fetch('/biz', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify(payload),
  });
  if (!res.ok) {
    //const {success,message} = resp.json();
    const err: any = await res.text();
    console.log('fileBiz.resp.error:', err);
    return Promise.reject(err.message || err || 'request failed...');
  }
  const blob = await res.blob();

  // const resp = await fetch(url, config);
  // console.log('bizfile.status: ', resp.status);
  // console.log('bizfile.statusText: ', resp.statusText);
  // console.log('bizfile.ok: ', resp.ok);
  // console.log('bizfile.headers: ', JSON.stringify(resp.headers));
  // if (!resp.ok) {
  //   //const {success,message} = resp.json();
  //   const err: any = await resp.text();
  //   console.log('bizfile.resp.error:', err);
  //   return Promise.reject(err.message || err || 'request failed...');
  // }
  // const blob = await resp.blob();
  return blob;
}

export const postBiz = async (payload: any) => {
  const res = await fetch('/biz', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify(payload),
  });

  const json = await res.json();
  if (!res.ok || json.failure || json.em) throw new Error(json.em || json.message || 'Request failed');
  return json;
};

export const json = (json: any): any => {
  const sd = json.sd || json.result?.sd || json.data?.sd || json;
  return sd || {};
};

export const rows = (json: any): any[] => {
  const sd = json.sd || json.result?.sd || json.data?.sd || json;
  return Array.isArray(sd) ? sd : [];
};

export const normalizeCombo = (r: any) => ({
  rid: r.rid ?? r.recid ?? r.id,
  shc: r.shc ?? r.shortcode ?? r.code ?? r.nam ?? r.recname ?? '',
  nam: r.nam ?? r.recname ?? r.name ?? r.shc ?? r.shortcode ?? '',
  raw: r,
});

export const fetchCombo = async (service: string, params?: any) =>
  rows(await postBiz({ s: service, a: 'combo', ...(params || {}) })).map(normalizeCombo);

// private postBiz = async (payload: any) => {
//     const res = await fetch('/biz', {
//       method: 'POST',
//       headers: { 'Content-Type': 'application/json' },
//       credentials: 'include',
//       body: JSON.stringify(payload), 
//     });

//     const json = await res.json();

//     if (!res.ok || json.failure) {
//       throw new Error(json.em || json.message || 'Request failed');
//     }

//     return json;
//   };

//   private jsonRows = (json: any): ComboRow[] => {
//     const sd = json.sd || json.result?.sd || json.data?.sd || json;
//     return Array.isArray(sd) ? sd : [];
//   };

//   private fetchCombo = async (service: string): Promise<ComboRow[]> => {
//     const json = await this.postBiz({ s: service, a: 'combo' });
//     return this.jsonRows(json);
//   };


//
export const uploadBiz = async ({
  prefix,
  service,
  action,
  file,
  params = {},
}: Partial<IUpload>) => {
  const formData: any = new FormData();

  formData.append('file', file, file?.name);
  formData.append('s', service);
  formData.append('a', action);
  //formData.append('prefix', prefix);

  if(params['tki'] === undefined){
    formData.append('tki',generateTrackId());
  }

  Object.keys(params || {}).forEach((key) => {
    const val = params[key];

    if (val instanceof File) {
      const { name: filename } = val;
      formData.append('file', val, filename);
      formData.append(key, filename);
    }
    // else {
    //   formData.append(key, val);
    // }

    else if (val === undefined || val === null) {
      formData.append(key, '');
    } else if (typeof val === 'object') {
      formData.append(key, JSON.stringify(val));
    } else {
      formData.append(key, String(val));
    }
  });

  // overwrite params
  formData.append('fln', file?.name);

  const config: any = {
    method: 'POST',
    credentials: 'include',
    headers: new Headers(),
    body: formData._blob ? formData._blob() : formData,
  };

  const resp = await fetch(`/biz/file/${prefix}`, config);
  const response = await resp.json();

  if (response.success) return response;

  if (response.failure) {
    return Promise.reject({
      name: 'fetcherror',
      title: response.et || 'Upload Error',
      message: response.em || 'Upload failed',
      data: response,
    });
  }

  return Promise.reject({
    name: 'fetcherror',
    title: 'Upload Error',
    message: 'Upload failed',
    data: response,
  });
};